import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/wheel/ico_loading.svg")